var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 45,
    viewBox: "0 0 30 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9052 10.0947L15.0947 10.0947L15.0947 14.9052L19.9052 14.9052L19.9052 10.0947Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.189333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9052 15.0947L20.0946 15.0947L20.0946 19.9052L24.9052 19.9052L24.9052 15.0947Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.189333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9052 34.9053L15.0947 34.9053L15.0947 30.0948L19.9052 30.0948L19.9052 34.9053Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.189333
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9052 34.9053L15.0947 34.9053L15.0947 30.0948L19.9052 30.0948L19.9052 34.9053Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.189333
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9052 39.9053L10.0947 39.9053L10.0947 35.0948L14.9052 35.0948L14.9052 39.9053Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.189333
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90522 44.9053L5.09467 44.9053L5.09467 40.0948L9.90522 40.0948L9.90522 44.9053Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.189333
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90522 44.9053L0.0946665 44.9053L0.0946663 40.0948L4.90522 40.0948L4.90522 44.9053Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.189333
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9052 9.90533L10.0947 9.90533L10.0947 5.09478L14.9052 5.09478L14.9052 9.90533Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.189333
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90522 4.90533L5.09467 4.90533L5.09467 0.0947847L9.90522 0.0947845L9.90522 4.90533Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.189333
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90522 4.90533L0.0946665 4.90533L0.0946663 0.0947847L4.90522 0.0947845L4.90522 4.90533Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.189333
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90522 9.90533L0.0946665 9.90533L0.0946663 5.09478L4.90522 5.09478L4.90522 9.90533Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.189333
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90522 14.9053L0.0946665 14.9053L0.0946663 10.0948L4.90522 10.0948L4.90522 14.9053Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.189333
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90522 19.9053L0.0946665 19.9053L0.0946663 15.0948L4.90522 15.0948L4.90522 19.9053Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.189333
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90522 24.9053L0.0946665 24.9053L0.0946663 20.0948L4.90522 20.0948L4.90522 24.9053Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.189333
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90522 29.9053L0.0946665 29.9053L0.0946663 25.0948L4.90522 25.0948L4.90522 29.9053Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.189333
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90522 34.9053L0.0946665 34.9053L0.0946663 30.0948L4.90522 30.0948L4.90522 34.9053Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.189333
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90522 39.9053L0.0946665 39.9053L0.0946663 35.0948L4.90522 35.0948L4.90522 39.9053Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.189333
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9051 24.9058L25.0945 24.9058L25.0945 20.0953L29.9051 20.0953L29.9051 24.9058Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.189333
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9052 29.9053L20.0946 29.9053L20.0946 25.0948L24.9052 25.0948L24.9052 29.9053Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.189333
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBtn);
export default __webpack_public_path__ + "static/media/play-btn.bd64f174.svg";
export { ForwardRef as ReactComponent };